import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CertificatesService } from "../../services/certificates.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { TramitacionService } from "src/app/core/services/tramitacion.service";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { CommonService } from "src/app/core/services/common.service";
import { DynamicFieldsComponent } from "src/app/shared/dynamic-fields/dynamic-fields.component";
import { TranslateService } from "@ngx-translate/core";
import { TokenService } from "src/app/core/services/token.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { RoutingStatesService } from "src/app/core/services/routingStates.service";
import { AppConstants } from "src/app/constants/app.constants";
import { ListRelatedRequests } from "src/app/shared/models/listRelatedRequest";
import { TableConstants } from "src/app/constants/tableConstants";
import { RoutingStates } from "src/app/core/models/routingStates";
import { dynamicsFields } from "src/app/coc/models/dynamicsFields";
import { RichTextEditorComponent } from "src/app/shared/rich-text-editor/rich-text-editor.component";
import { CommentsHistoryPeticionComponent } from "src/app/shared/comments-history-peticion/comments-history-peticion.component";
import { StatesComponent } from "src/app/shared/states/states.component";
import { ViewerPDFComponent } from "src/app/shared/viewer-pdf/viewer-pdf.component";
import { ConvertToPDFService } from "src/app/core/services/convertToPDF.service";
import {
  FieldBase,
  InputTextField,
  ShowField,
  TextareaField,
} from "src/app/shared/form-fields/model";
import * as moment from "moment";
import { FormFieldsComponent } from "src/app/shared/form-fields/form-fields.component";
import { ListValueService } from "src/app/core/services/list-value.service";
import { SelectorWithSearchField } from "src/app/shared/form-fields/model/selector-with-search-field.model";
import { ConcessionaireService } from "src/app/maintenance-concessionaire/concessionaire.service";

@Component({
  selector: "app-detail-mailbox",
  templateUrl: "./detail-mailbox.component.html",
  styleUrls: ["./detail-mailbox.component.scss"],
})
export class DetailMailboxComponent implements OnInit {
  @ViewChild("dynamicFields") dynamicFields: DynamicFieldsComponent;
  @ViewChild(RichTextEditorComponent) editor: RichTextEditorComponent;
  @ViewChild("states") states: StatesComponent;
  @ViewChild("vehiculo") vehiculoFields: FormFieldsComponent;
  @ViewChild("comentario") comentarioFields: FormFieldsComponent;
  @ViewChild(CommentsHistoryPeticionComponent)
  commentsHistory: CommentsHistoryPeticionComponent;
  @ViewChild(ViewerPDFComponent) viewerPDF: ViewerPDFComponent;

  public fieldsSolicitud: FieldBase<any>[];
  public fieldsVehiculo: FieldBase<any>[];
  public fieldsComentario: FieldBase<any>[];

  certificate;
  changeToStatePF = {
    isAtStatePF: false,
    watchBoth: false,
    onlyWatchDetail: false,
    onlyWatchEditor: false,
    values: {
      price: "",
      template: { 0: "", 1: "", 2: "", 3: "" },
      html: "",
    },
    templateList: null,
    htmlList: { 0: "", 1: "", 2: "", 3: "" },
  };
  roles = AppConstants.roles;
  fields: dynamicsFields[];
  certificateAux = {};
  fieldsAux = {};
  routing = RoutingConstants.certificatesMailBox;
  id: string;
  operation: string;
  type: string;
  sectionHidden = {
    peticion: false,
    vehiculo: false,
    detalle: false,
    obs: false,
  };
  onlyViewImpreso = false;
  userIdConected: string;
  config: ListRelatedRequests;
  routingStates: RoutingStates;
  onlyViewPdf = false;
  pdfURL: string;
  brandsList = [];
  private regionCpeticionario: string;

  constructor(
    private certificatesService: CertificatesService,
    private toastrAlertService: ToastrAlertService,
    private listValueService: ListValueService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private commonService: CommonService,
    private tramitacionService: TramitacionService,
    private tokenService: TokenService,
    private sweetAlertService: SweetAlertService,
    private routingStatesService: RoutingStatesService,
    private convertToPDFService: ConvertToPDFService,
    private concessionaireService: ConcessionaireService
  ) {
    this.userIdConected = this.tokenService.getUserName();
    this.config = {
      type: "CERTIFICATES",
      bastidor: "",
      title: "Más certificados",
      opened: false,
      tableContasts: TableConstants.certificatesQuery,
      optionsTable:
        TableConstants.NotShowCreateDeleteAndArrowUpDownFiltersButtonAndShowLabel,
      routingTableEnTramite: RoutingConstants.certificatesQuery,
      routingTableHistory: RoutingConstants.certificatesQueryHistory,
    };
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((data) => {
      this.init();
    });
  }

  init() {
    this.routingStates = this.routingStatesService.getRoutingStates();
    this.id = this.activatedRoute.snapshot.params.id;
    this.operation = this.activatedRoute.data["_value"]["operation"];
    this.type = this.activatedRoute.data["_value"]["type"];
    this.fields = null;
    this.brandsList = [];
    this.getBrands();
    if (this.type == "history") {
      this.getHistoryQueryCertificate();
    } else if (this.type == "NotHistory") {
      this.getQueryDetailCertificate();
    } else {
      this.getCertificateMailbox();
    }
  }
  private showEditorFirst(): boolean {
    if (
      (this.tokenService.hasRole(this.roles.RHOMOLOG) ||
        this.tokenService.hasRole(this.roles.REVISOR) ||
        this.tokenService.hasRole(this.roles.ABASICO) ||
        this.tokenService.hasRole(this.roles.ANALISTA) ||
        this.tokenService.hasRole(this.roles.AAVANZA)) &&
      (this.certificate.peEstado == "PF" ||
        this.certificate.peEstado == "CR" ||
        this.certificate.peEstado == "CA")
    ) {
      if (
        (this.tokenService.hasRole(this.roles.RHOMOLOG) ||
          this.tokenService.hasRole(this.roles.REVISOR)) &&
        this.certificate.peEstado == "CA"
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  private async hasRolesToViewImpreso() {
    this.regionCpeticionario =
      await this.convertToPDFService.getRegionByConcesionaire(
        this.certificate.peCpeticionario
      );
    if (this.showEditorFirst()) {
      this.viewPDFOrEditor();
      this.cloneObjectIfIsEdited();
    }
  }

  private viewPDFOrEditor(): void {
    this.onlyViewImpreso = true;
    this.changeToStatePF.isAtStatePF = true;
    this.changeToStatePF.watchBoth = true;

    if (this.certificate.peTcertificado != "OD") {
      if (
        (this.certificate.peEstado == "PF" ||
          this.certificate.peEstado == "CR") &&
        (this.tokenService.hasRole(this.roles.RHOMOLOG) ||
          this.tokenService.hasRole(this.roles.REVISOR))
      ) {
        this.onlyViewPdf = true;
        this.certificatesService
          .downloadFileOfPetition(
            this.type == "history" ? "true" : "false",
            "PeImpreso",
            this.certificate.peId,
            this.certificate.peRelease
          )
          .subscribe((data) => {
            this.getPDFConverted(data);
          });
      } else {
        this.getTemplatesByCertStatePF();
        this.getImpresoOfCertificate();
      }
    } else {
      this.onlyViewPdf = true;
      this.certificatesService
        .downloadFileOfPetition(
          this.type == "history" ? "true" : "false",
          "FichaTecnica",
          this.certificate.peId,
          this.certificate.peRelease
        )
        .subscribe((data) => {
          const file = new Blob([data], { type: "application/pdf" });
          this.pdfURL = URL.createObjectURL(file);
        });
    }
  }

  getCertificateMailbox() {
    this.certificatesService.getCertificate(this.id).subscribe(
      (data) => {
        this.fields = this.convertFilesOfPetitionToDynamicFields(data);
        data.peTcertificado = this.getReformas(
          this.fields,
          data.peTcertificado,
          data.peReforma
        );
        this.config.bastidor = data.peBastidor;
        this.certificate = data;
        this.changeToStatePF.values.price =
          this.certificate?.peTcertificado == "OD"
            ? 0
            : this.certificate.pePrecio;
        this.initFields();
        this.convertToPDFService.getImg(this.certificate.peMarca);
        this.hasRolesToViewImpreso();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getHistoryQueryCertificate() {
    this.certificatesService
      .getQueryHistoryDetailCertificates(this.id)
      .subscribe(
        (data) => {
          this.fields = this.convertFilesOfPetitionToDynamicFields(data);
          data.peTcertificado = this.getReformas(
            this.fields,
            data.peTcertificado,
            data.peReforma
          );
          this.config.bastidor = data.peBastidor;
          this.certificate = data;
          this.changeToStatePF.values.price =
            this.certificate?.peTcertificado == "OD"
              ? 0
              : this.certificate.pePrecio;
          this.initFields();
          this.convertToPDFService.getImg(this.certificate.peMarca);
          this.hasRolesToViewImpreso();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  getQueryDetailCertificate() {
    this.certificatesService.getQueryDetailCertificates(this.id).subscribe(
      (data) => {
        this.fields = this.convertFilesOfPetitionToDynamicFields(data);
        data.peTcertificado = this.getReformas(
          this.fields,
          data.peTcertificado,
          data.peReforma
        );
        this.config.bastidor = data.peBastidor;
        this.certificate = data;
        this.changeToStatePF.values.price =
          this.certificate?.peTcertificado == "OD"
            ? 0
            : this.certificate.pePrecio;
        this.initFields();
        this.convertToPDFService.getImg(this.certificate.peMarca);
        this.hasRolesToViewImpreso();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  private getReformas(
    fields: any[],
    tipoCertificate: string,
    peReforma: string
  ): string {
    if (tipoCertificate == "RE") {
      const anyNotNull = (element) => element.dpReforma !== null;

      if (!fields.some(anyNotNull)) {
        return tipoCertificate + " " + peReforma;
      }

      let reformas: string[] = [];

      fields.forEach((e) => {
        let pos = reformas.findIndex(
          (item) => item == e.dpReforma?.split("-")[0]?.trim()
        );
        if (pos == -1) {
          reformas.push(e.dpReforma ? e.dpReforma.split("-")[0]?.trim() : "");
        }
      });

      reformas.sort((a, b) => {
        return parseInt(a.split(".")[0]) > parseInt(b.split(".")[0])
          ? 1
          : parseInt(a.split(".")[0]) < parseInt(b.split(".")[0])
          ? -1
          : parseInt(a.split(".")[1]) > parseInt(b.split(".")[1])
          ? 1
          : parseInt(a.split(".")[1]) < parseInt(b.split(".")[1])
          ? -1
          : 0;
      });

      reformas.forEach((reforma, i) => {
        if (i > 0 && i < reformas.length) {
          tipoCertificate = tipoCertificate + ",";
        }
        tipoCertificate = tipoCertificate + " " + reforma;
      });
    }
    return tipoCertificate;
  }

  private createAndGetField(
    nombreCampo: string,
    nombreFichero: string,
    campoId: string,
    type: string
  ): dynamicsFields {
    let field: dynamicsFields = {
      dpCampo: nombreCampo,
      dpId: "",
      dpRelease: 0,
      dpValor: "",
      dpFichero: nombreFichero,
      dpDocumentacion: "",
      dpCampoid: campoId,
      camposdisponibles: {
        ccObligatorio: null,
        cdId: "",
        cdListadb: "",
        cdLongitud: 0,
        cdTexto: "",
        cdTipo: type,
      },
    };
    return field;
  }

  private convertFilesOfPetitionToDynamicFields(data): dynamicsFields[] {
    let fields: dynamicsFields[] = data.detallepeticiones
      ? data.detallepeticiones
      : [];

    if (data.peFnameFichatecnica && data.peFnameFichatecnica != "") {
      let field = this.createAndGetField(
        "Documentación",
        data.peFnameFichatecnica,
        "FichaTecnica",
        "FILE"
      );

      fields.push(field);
    }

    if (data.peFnameDocadicional && data.peFnameDocadicional != "") {
      let field = this.createAndGetField(
        "Documentación adicional",
        data.peFnameDocadicional,
        "DocAdcional",
        "FILE"
      );

      fields.push(field);
    }
    return fields;
  }

  goList() {
    if (this.routingStates) {
      this.router.navigate([
        this.routingStates.urlBefore,
        this.routingStates.urlBeforeId,
      ]);
    } else if (this.activatedRoute.data["_value"]["url"] == "consulta") {
      this.router.navigate([RoutingConstants.certificatesQuery.list]);
    } else {
      this.router.navigate([this.routing.list]);
    }
  }

  goEdit() {
    this.operation = "edit";
    this.initFields();
    this.dynamicFields.getDynamicDBLists();
  }

  goDetail(type?: string) {
    this.operation = "detail";
    this.initFields();
    if (type == "Edited") {
      this.cloneObjectIfIsEdited();
      let formComentario = this.comentarioFields.getForm();
      this.certificate.peComentarios = formComentario.value.comentario;
    } else {
      this.cloneObject();
    }
  }

  onSave() {
    let formComentario = this.comentarioFields.getForm();
    if (
      formComentario &&
      this.commonService.validationRequiredDynamicFields(
        this.dynamicFields.fields
      )
    ) {
      this.formatToSave();
      let form = this.vehiculoFields.getForm();
      let detallePeticiones =
        this.certificate.peTcertificado == "OD"
          ? []
          : this.dynamicFields.fields.filter(
              (obj) => obj.camposdisponibles.cdId !== "GRUPO"
            );
      let valueToSend = {
        peComentarios: formComentario.value.nuevoComentario,
        peBastidor: form.value.bastidor,
        peMatricula: form.value.matricula,
        peMarca: this.certificate.peMarca,
        peId: this.certificate.peId,
        peRelease: this.certificate.peRelease,
        detallepeticiones: detallePeticiones,
      };

      this.sweetAlertService.sweetAlertLoading();
      this.certificatesService
        .updateCertificate(valueToSend, this.dynamicFields.files)
        .subscribe(
          (data) => {
            this.sweetAlertService.sweetAlertClose();
            this.toastrAlertService.toastrSuccess(data.mensaje);
            this.commentsHistory.commentsHistory.loaded = false;
            this.certificate = null;
            this.init();
          },
          (err) => {
            this.sweetAlertService.sweetAlertClose();
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
  }

  formatToSave() {
    this.dynamicFields.files.forEach((e, index) => {
      this.certificate.detallepeticiones[e.index].dpFichero = index;
    });

    this.dynamicFields.fields.forEach((e) => {
      if (
        e.camposdisponibles &&
        (e.camposdisponibles.cdTipo == "DBLIST" ||
          e.camposdisponibles.cdTipo == "LIST") &&
        e.dpValor.valor
      ) {
        e.dpValor = e.dpValor.valor;
      }
    });
  }

  cloneObject() {
    for (let key in this.certificateAux) {
      this.certificate[key] = this.certificateAux[key];
    }
    for (let key in this.fieldsAux) {
      if (this.fieldsAux[key]["dpValor"]) {
        this.fields[key]["dpValor"] = this.fieldsAux[key]["dpValor"];
      } else {
        this.fields[key]["dpFichero"] = this.fieldsAux[key]["dpFichero"];
      }
    }
  }

  cloneObjectIfIsEdited() {
    for (let key in this.certificate) {
      this.certificateAux[key] = this.certificate[key];
    }
    for (let key in this.fields) {
      this.fieldsAux[key] = {};
      if (this.fields[key]["dpValor"]) {
        this.fieldsAux[key]["dpValor"] = this.fields[key]["dpValor"];
      } else {
        this.fieldsAux[key]["dpFichero"] = this.fields[key]["dpFichero"];
      }
    }
    this.dynamicFields?.files.forEach((e) => {
      this.fields[e.index].dpFichero = e.name;
      this.fieldsAux[e.index].dpFichero = e.name;
    });
  }

  private changeStateToPF(): void {
    let usedTemplates = "";
    let size = Object.keys(this.changeToStatePF.values.template).length;

    for (let i = 0; i < size; i++) {
      let item = this.changeToStatePF.values.template[i];
      if (item !== "") {
        usedTemplates += "____" + item;
      }
    }
    let editorData = null;
    if (this.editor && this.editor.Editor && this.editor.Editor.getData()) {
      editorData = this.convertToPDFService.applyMissingStyles(
        this.editor.Editor.getData()
      );
    }

    this.sweetAlertService.sweetAlertLoading();
    this.tramitacionService
      .changeStateToPF(
        this.certificate.peId,
        editorData,
        this.changeToStatePF.values.price,
        usedTemplates.substring(4)
      )
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            let newData = [];
            let keys = [];

            data[0].forEach((item) => {
              let value = item.plantilla;
              let keyValue = value.substring(0, value.indexOf("_"));
              let keyIndex = keys.findIndex((element) => element == keyValue);

              if (keyIndex === -1) {
                keys.push(keyValue.toString());
                keyIndex = keys.findIndex((element) => element == keyValue);
                newData.push([]);
                newData[keyIndex].push(item);
              } else {
                newData[keyIndex].push(item);
              }
            });
            this.changeToStatePF.templateList = newData;
          }

          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.goList();
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  validateChangeStateToPF() {
    if (
      !(
        this.certificate.peEstado == "CA" &&
        this.certificate.peTcertificado == "OD"
      )
    ) {
      if (
        this.certificate.peTcertificado != "OD" &&
        this.certificate.peImpreso != null
      ) {
        this.changeStateToPF();
      } else {
        const noEditorData =
          this.editor != null &&
          this.editor.Editor != null &&
          this.editor.Editor.getData() == "";
        const noPrice = this.changeToStatePF.values.price == null;
        const priceLessThanZero =
          parseInt(this.changeToStatePF.values.price) < 0;
        const priceNotValidNumber = isNaN(
          parseInt(this.changeToStatePF.values.price)
        );
        if (
          noEditorData ||
          noPrice ||
          priceLessThanZero ||
          priceNotValidNumber
        ) {
          console.log(this.changeToStatePF.values.price);
          let message = "El precio es requerido y debe ser un número";
          this.toastrAlertService.toastrFail(message);
        } else {
          this.changeStateToPF();
        }
      }
    } else {
      this.changeStateToPF();
    }
  }

  private isNumber(number): boolean {
    return !isNaN(number);
  }

  decodificaBase64(input) {
    let output = null;
    try {
      output = decodeURIComponent(escape(atob(this.certificate.peImpreso)));
    } catch (e) {
      console.log(e);
      output = atob(this.certificate.peImpreso);
    }
    return output;
  }

  reloadDetail(state: string) {
    this.commentsHistory.commentsHistory.loaded = false;
    if (state == "PF") {
      if (this.changeToStatePF.isAtStatePF) {
        this.validateChangeStateToPF();
      } else {
        this.changeToStatePF.isAtStatePF = true;
        this.changeToStatePF.watchBoth = true;
        if (this.certificate.peTcertificado === "OD") {
          this.onlyViewPdf = true;
          this.certificatesService
            .downloadFileOfPetition(
              this.type == "history" ? "true" : "false",
              "FichaTecnica",
              this.certificate.peId,
              this.certificate.peRelease
            )
            .subscribe((data) => {
              const file = new Blob([data], { type: "application/pdf" });
              this.pdfURL = URL.createObjectURL(file);
            });
        } else if (this.certificate.peImpreso != null) {
          this.changeToStatePF.values.html = this.decodificaBase64(
            this.certificate.peImpreso
          );
        }

        this.getTemplatesByCertStatePF();
      }
    } else if (this.changeToStatePF.isAtStatePF || state == "RE") {
      this.goList();
    } else if (state == "FI" || state == "FG" || state == "EF") {
      this.router.navigate([
        RoutingConstants.certificatesQueryHistory.edit,
        this.certificate.peId,
      ]);
    } else if (state == "PA") {
      if (this.type == "history") {
        this.router.navigate([
          RoutingConstants.certificatesQuery.edit,
          this.certificate.peId,
        ]);
      } else {
        this.init();
      }
    } else {
      if (this.type != "history" && this.type != "NotHistory") {
        this.init();
      }
      if (this.type == "NotHistory") {
        this.init();
      } else {
        this.router.navigate([
          RoutingConstants.certificatesQuery.edit,
          this.certificate.peId,
        ]);
      }
    }
  }

  reasgine(value: string) {
    this.init();
  }

  getImpresoOfCertificate() {
    this.tramitacionService
      .getImpresoOfPetition(this.certificate.peId, this.certificate.peRelease)
      .subscribe(
        (data) => {
          this.changeToStatePF.values.html = data.fichero;
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  getTemplatesByCertStatePF() {
    this.tramitacionService
      .getTemplatesByCertStatePF(this.certificate.peId)
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            let newData = [];
            let keys = [];
            if (data.length > 0 && data[0]) {
              data[0] = this.sortAlphaNum(data[0]);
              data[0].forEach((item) => {
                let value = item.plantilla;
                let keyValue = value.substring(0, value.indexOf("|"));
                let keyIndex = keys.findIndex((element) => element == keyValue);

                if (keyIndex === -1) {
                  keys.push(keyValue.toString());
                  keyIndex = keys.findIndex((element) => element == keyValue);
                  newData.push([]);
                  newData[keyIndex].push(item);
                } else {
                  newData[keyIndex].push(item);
                }
              });
            }
            this.changeToStatePF.templateList = newData;
            if (!this.certificate.peImpreso) {
              for (
                let i = 0;
                i < this.changeToStatePF.templateList.length;
                i++
              ) {
                this.changeToStatePF.values.template[i] =
                  this.changeToStatePF.templateList[i][0].plantilla;
              }

              this.selectTemplates();
            }
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  parseToFloat(reform: string): number {
    let reformSplited = reform.trim().split(".");
    let floatCodigoReforma: number = 0.0;
    if (reformSplited.length > 1 && reformSplited[1].trim().length == 1) {
      reformSplited[0] = reformSplited[0] + ".0" + reformSplited[1].trim();
    } else {
      reformSplited[0] = reform;
    }

    floatCodigoReforma = parseFloat(reformSplited[0]);
    return floatCodigoReforma;
  }

  sortAlphaNum(data: any) {
    data.sort((a, b) => {
      let aSplited = a.plantilla.split("|");
      let bSplited = b.plantilla.split("|");
      if (aSplited.length > 0 && bSplited.length > 0) {
        const reformsOrder =
          this.parseToFloat(aSplited[0]) - this.parseToFloat(bSplited[0]);
        if (reformsOrder === 0) {
          return aSplited[1].localeCompare(bSplited[1]);
        } else {
          return reformsOrder;
        }
      } else {
        return 0;
      }
    });
    return data;
  }

  changeViewAtPF(type: string) {
    this.changeToStatePF.onlyWatchDetail = false;
    this.changeToStatePF.onlyWatchEditor = false;
    this.changeToStatePF.watchBoth = false;
    switch (type) {
      case "detail":
        this.changeToStatePF.onlyWatchDetail = true;
        break;
      case "editor":
        this.changeToStatePF.onlyWatchEditor = true;
        break;
      case "both":
        this.changeToStatePF.watchBoth = true;
        break;
      default:
        break;
    }
  }

  goOutFI() {
    this.changeToStatePF.onlyWatchDetail = false;
    this.changeToStatePF.onlyWatchEditor = false;
    this.changeToStatePF.watchBoth = false;
    this.changeToStatePF.isAtStatePF = false;
    if (this.showEditorFirst()) {
      this.goList();
    }
  }

  selectTemplates() {
    this.sweetAlertService.sweetAlertLoading();
    this.changeToStatePF.values.html = "";
    let templates = "";
    for (let i = 0; i < this.changeToStatePF.templateList.length; i++) {
      let value = this.changeToStatePF.values.template[i];
      templates +=
        i == 0
          ? value.substring(value.indexOf("|") + 1)
          : "__" + value.substring(value.indexOf("|") + 1);
    }
    this.tramitacionService
      .selectTemplatesAndGetInfo(this.certificate.peId, templates)
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            let html = "";
            data.forEach((element) => {
              if (element && element.length > 1) html += element[1];
            });
            this.changeToStatePF.values.html = html;
          }
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  downloadFile(field: dynamicsFields) {
    this.sweetAlertService.sweetAlertLoading();
    if (field.dpCampoid == "DocAdcional" || field.dpCampoid == "FichaTecnica") {
      this.certificatesService
        .downloadFileOfPetition(
          this.type == "history" ? "true" : "false",
          field.dpCampoid,
          this.certificate.peId,
          this.certificate.peRelease
        )
        .subscribe(
          (data) => {
            this.commonService.downloadFile(data, field.dpFichero);
            this.sweetAlertService.sweetAlertClose();
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
            this.sweetAlertService.sweetAlertClose();
          }
        );
    } else {
      this.commonService
        .getFilesOfDetallePeticiones(
          field.dpCampo,
          field.dpId,
          field.dpRelease.toString(),
          this.type == "history" ? "true" : "false"
        )
        .subscribe(
          (data) => {
            this.commonService.downloadFile(data, field.dpFichero);
            this.sweetAlertService.sweetAlertClose();
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
            this.sweetAlertService.sweetAlertClose();
          }
        );
    }
  }

  private getPDFConverted(data: Blob): void {
    this.commonService
      .blobATexto(data)
      .then((texto) => {
        this.convertPDF(texto);
      })
      .catch((error) => {
        this.toastrAlertService.toastrFail(
          "Error al convertir el blob a texto"
        );
        this.sweetAlertService.sweetAlertClose();
      });
  }

  private convertPDF(text: any): void {
    this.convertToPDFService.setLoadedFooterAndHeader();
    let marca =
      this.regionCpeticionario === "CANARIAS"
        ? "CANARIAS"
        : this.certificate?.peMarca;
    this.convertToPDFService
      .previewPDF(
        text,
        this.activatedRoute.snapshot.params.id,
        "111111111111",
        this.certificate?.peEstado,
        this.certificate?.peTcertificado,
        "return",
        this.certificate?.peRevisor,
        marca,
        null,
        this.certificate?.peMarca
      )
      .then((data) => {
        this.sweetAlertService.sweetAlertClose();
        data.getBlob((blob) => {
          this.pdfURL = URL.createObjectURL(blob);
        });
      })
      .catch((error) => {
        this.toastrAlertService.toastrFail(
          "Error al convertir el contenido a PDF"
        );
        this.sweetAlertService.sweetAlertClose();
      });
  }

  previewPDF() {
    console.log(
      "Haciendo preview del pdf de la petición [" +
        this.activatedRoute.snapshot.params.id +
        "]"
    );
    this.convertToPDFService.setLoadedFooterAndHeader();
    let marca =
      this.regionCpeticionario === "CANARIAS"
        ? "CANARIAS"
        : this.certificate?.peMarca;
    this.convertToPDFService.previewPDF(
      this.editor.Editor.getData(),
      this.activatedRoute.snapshot.params.id,
      "111111111111",
      this.certificate?.peEstado,
      this.certificate?.peTcertificado,
      "open",
      this.certificate?.peRevisor,
      marca,
      null,
      this.certificate?.peMarca
    );
  }

  public isRHomologOrRevi(): boolean {
    if (
      this.tokenService.hasRole(this.roles.RHOMOLOG) ||
      this.tokenService.hasRole(this.roles.REVISOR)
    ) {
      return true;
    } else {
      return false;
    }
  }

  public isAnalist(): boolean {
    if (
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.ABASICO) ||
      this.tokenService.hasRole(this.roles.AAVANZA)
    ) {
      return true;
    } else {
      return false;
    }
  }

  public isAnalistNoBasic(): boolean {
    if (
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.AAVANZA)
    ) {
      return true;
    } else {
      return false;
    }
  }
  
  public isAdmin(): boolean {
    if (
      this.tokenService.hasRole(this.roles.ADMIN)
    ) {
      return true;
    } else {
      return false;
    }
  }

  private initFields(): void {
    this.fieldsComentario = [];
    this.fieldsSolicitud = [
      new ShowField({
        label: "ID",
        value: this.certificate.peId,
      }),
      new ShowField({
        label: "Tipo certificado",
        value: this.certificate.peTcertificado,
      }),
      new ShowField({
        label: "Fecha solicitud",
        value: this.certificate.peCreacion
          ? moment(this.certificate.peCreacion).format("DD/MM/yyyy")
          : "",
      }),
      new ShowField({
        label: "Hora solicitud",
        value: this.certificate.peCreacion
          ? moment(this.certificate.peCreacion).format("HH:mm:ss")
          : "",
      }),
      new ShowField({
        label: "Concesionario",
        value: this.certificate.peCpeticionario,
      }),
      new ShowField({
        label: "Usuario",
        value:
          this.certificate?.usId +
          " - " +
          this.certificate?.usNombre +
          " " +
          (this.certificate?.usApellido1 ? this.certificate?.usApellido1 : "") +
          " " +
          (this.certificate?.usApellido2 ? this.certificate?.usApellido2 : ""),
      }),
      new ShowField({
        label: "Teléfono",
        value: this.certificate?.usTelefono,
      }),
      new ShowField({
        label: "Estado",
        value: this.certificate?.peEstado,
      }),
      new ShowField({
        label: "Fecha tramitación",
        value: this.certificate.peEntrega
          ? moment(this.certificate.peEntrega).format("DD/MM/yyyy")
          : "",
      }),
      new ShowField({
        label: "Fecha facturación",
        value: this.certificate.peFactura
          ? moment(this.certificate.peFactura).format("DD/MM/yyyy")
          : "",
      }),
    ];
    if (
      (this.isRHomologOrRevi() || this.isAnalistNoBasic() || this.isAdmin()) &&
      (this.certificate?.peEstado == "FI" || this.certificate?.peEstado == "EF")
    ) {
      this.fieldsSolicitud.push(
        new ShowField({
          label: "Precio (€)",
          value: this.certificate.pePrecio,
        })
      );
    }
    this.fieldsVehiculo = [
      new InputTextField({
        label: "Número de bastidor",
        value: this.certificate.peBastidor,
        formControlName: "bastidor",
        onlyShow:
          this.operation != "edit" || this.certificate.peTcertificado == "OD",
        onlyUpperCase: true,
      }),
      new ShowField({
        label: "Código VIN",
        value: this.getCodigoVin(),
      }),
      new ShowField({
        label: "Variante",
        value: this.certificate.peVariante,
      }),
      new ShowField({
        label: "Versión",
        value: this.certificate.peVersion,
      }),
      new ShowField({
        label: "Contraseña",
        value: this.certificate.pePassword,
      }),
      new SelectorWithSearchField({
        label: "Marca",
        value: this.certificate.peMarca,
        selectorList: this.brandsList,
        selectorFields: ["maId", "maDescr"],
        selectorId: "maId",
        selectorItem: this.brandsList.find(
          (item) => item.maId == this.certificate.peMarca
        ),
        selectorSendValue: (event) => {
          this.valueSelectorMarca(event);
        },
        formControlName: "marca",
        onlyShow:
          this.operation != "edit" ||
          this.tokenService.hasRole(this.roles.CONCES) ||
          this.certificate.peTcertificado == "OD",
      }),
      new ShowField({
        label: "Denominación comercial",
        value: this.certificate.peDenominacion,
      }),
      new ShowField({
        label: "Código motor",
        value: this.certificate.peTipomotor,
      }),
      new InputTextField({
        label: "Matrícula",
        value: this.certificate.peMatricula,
        formControlName: "matricula",
        onlyShow:
          this.operation != "edit" || this.certificate.peTcertificado == "OD",
        onlyUpperCase: true,
      }),
    ];
    if (this.operation == "edit") {
      this.fieldsComentario = [
        new TextareaField({
          label: "Último Comentario",
          value: this.certificate.peComentarios,
          formControlName: "comentario",
          style: { "min-height": "50px" },
          onlyShow: true,
        }),
        new TextareaField({
          label: "Nuevo comentario",
          value: "",
          formControlName: "nuevoComentario",
          style: { "min-height": "100px" },
          required: true,
        }),
        new ShowField({
          label: "Observaciones",
          value: this.certificate.peObservaciones,
          style: { "min-height": "50px" },
        }),
      ];
    } else {
      this.fieldsComentario = [
        new TextareaField({
          label: "Comentario",
          value: this.certificate.peComentarios,
          formControlName: "comentario",
          style: { "min-height": "50px" },
          onlyShow: true,
        }),
        new TextareaField({
          label: "Nuevo comentario",
          value: "",
          formControlName: "nuevoComentario",
          style: { height: "100px" },
          hide: true,
          required: true,
        }),
        new ShowField({
          label: "Observaciones",
          value: this.certificate.peObservaciones,
          style: { "min-height": "50px" },
        }),
      ];
    }
  }

  private getCodigoVin(): string {
    if (this.certificate.peTipoh != null && this.certificate.peTipoh != "") {
      return this.certificate.peTipoh;
    }
    return this.certificate.peTipov;
  }

  public isReforma(): string {
    return this.certificate.peTcertificado.includes("RE")
      ? "REFORMA"
      : "CERTIFICADO";
  }

  getBrands() {
    this.listValueService.listValuesMarcas().subscribe(
      (data) => {
        this.brandsList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  valueSelectorMarca(event: any) {
    if (event.item != undefined) {
      this.certificate.peMarca = event.item[event.id];
    }
  }

  isAnalistaTramitante(): boolean {
    return this.userIdConected === this.certificate.analistaId;
  }

  public readOnlyPrice(): boolean {
    if (this.certificate?.peEstado == "CA" && this.isAnalistaTramitante()) {
      return false;
    } else if (this.onlyViewImpreso) {
      return true;
    } else if (
      this.certificate?.peEstado === "PA" ||
      (this.certificate?.peEstado === "AN" && this.isAnalistaTramitante())
    ) {
      return false;
    } else {
      return true;
    }
  }

  public showTemplateList(): boolean {
    if (
      this.certificate?.peEstado !== "CR" &&
      this.certificate?.peTcertificado != "OD"
    ) {
      if (!this.onlyViewImpreso && !this.changeToStatePF.onlyWatchEditor) {
        return true;
      } else if (
        this.onlyViewImpreso &&
        this.isRHomologOrRevi() &&
        !this.changeToStatePF.onlyWatchEditor
      ) {
        return true;
      } else if (
        this.certificate?.peEstado == "CA" &&
        this.isAnalistaTramitante()
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public showReasigneAnalyst(): boolean {
    if (this.certificate == null) return false;
    if (this.certificate.peEstado == null) return false;
    if (this.certificate.peEstado != "AN" && this.certificate.peEstado != "CA")
      return false;
    return true;
  }
}
